export function PagePlaceHolder({
	title,
	description,
	Icon,
}: {
	title: string;
	description: string;
	Icon: any;
}) {
	return (
		<div className="p-8 h-full bg-foreground/30 flex flex-col items-center justify-center text-muted-foreground">
			<div className="bg-card p-8 rounded-2xl border border-border text-center max-w-md shadow-sm">
				<div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
					<Icon className="h-8 w-8 text-muted-foreground" />
				</div>
				<h2 className="text-xl font-bold text-foreground mb-2">{title}</h2>
				<p className="mb-4 text-muted-foreground">{description}</p>
			</div>
		</div>
	);
}
